import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizTitlePresenter;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import EditButton from '../../editButton/EditButton';
import QuizTitleEdit from '../Edit';
import QuizTitleShow from '../Show';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';

// ================================

// renders the editable quiz title
// input/display component

// ================================

export var QuizTitlePresenter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizTitlePresenter = /*#__PURE__*/function (_Component) {
  function QuizTitlePresenter() {
    var _this;
    _classCallCheck(this, QuizTitlePresenter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, QuizTitlePresenter, [].concat(args));
    _defineProperty(_this, "workingTitle", function () {
      return _this.props.workingQuiz.title;
    });
    // =========
    //  actions
    // =========
    _defineProperty(_this, "saveAndPreview", function () {
      var fromEnterPressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.saveWorkingTitle();
      _this.props.onQuizUpdated({
        id: _this.quizID(),
        title: _this.props.workingQuiz.title
      });
      _this.props.switchOffEditing();
      if (fromEnterPressed && _this.editButton) {
        _this.editButton.wrappedInstance.setFocus();
      }
    });
    _defineProperty(_this, "updateWorkingTitle", function (e) {
      _this.props.changeQuizTitle(_this.quizID(), e.target.value);
    });
    _defineProperty(_this, "toggleEditing", function () {
      if (_this.props.isEditing) {
        _this.props.screenreaderNotification(t('Title edit mode off.'));
        _this.saveAndPreview();
      } else {
        _this.props.screenreaderNotification(t('Title switched to edit mode.'));
        _this.props.switchOnEditing();
      }
    });
    _defineProperty(_this, "handleEditButtonRef", function (node) {
      return _this.editButton = node;
    });
    return _this;
  }
  _inherits(QuizTitlePresenter, _Component);
  return _createClass(QuizTitlePresenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }

    // ===========
    //   helpers
    // ===========
  }, {
    key: "quizID",
    value: function quizID() {
      return this.props.quiz.id;
    }
  }, {
    key: "titleErrors",
    value: function titleErrors() {
      return this.props.workingQuiz.errorsFor('title');
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.props.workingQuiz.isValid();
    }
  }, {
    key: "isContentLocked",
    value: function isContentLocked() {
      var _this$props = this.props,
        lockBlueprintContentEnabled = _this$props.lockBlueprintContentEnabled,
        quiz = _this$props.quiz;
      return lockBlueprintContentEnabled && quiz.originalQuizLockedByBlueprint;
    }
  }, {
    key: "saveWorkingTitle",
    value: function saveWorkingTitle() {
      this.props.saveQuizChange(this.props.workingQuiz, this.props.quiz);
    }
  }, {
    key: "renderEdit",
    value:
    // ===============
    //    rendering
    // ===============

    function renderEdit() {
      var quizTitleEditKey = 'quiz_title_edit';
      return jsx(QuizTitleEdit, {
        isValid: this.isValid(),
        showError: partial(this.props.showError, quizTitleEditKey),
        hideError: partial(this.props.hideError, quizTitleEditKey),
        errorsAreShowing: this.props.errorsShowing.get(quizTitleEditKey),
        errors: this.titleErrors(),
        value: this.workingTitle(),
        onInputChange: this.updateWorkingTitle,
        saveAndPreview: this.saveAndPreview
      });
    }
  }, {
    key: "renderShow",
    value: function renderShow() {
      return jsx(QuizTitleShow, {
        switchOnEditing: this.props.switchOnEditing,
        defaultTitle: this.workingTitle(),
        contentLocked: this.isContentLocked(),
        scrollKey: this.isContentLocked() ? this.props.scrollKey : undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.props.isEditing ? this.renderEdit() : this.renderShow();
      return jsx("div", {
        tabIndex: "-1",
        css: this.props.styles.topRow
      }, jsx("div", {
        css: this.props.styles.flexContainer
      }, jsx("div", {
        css: this.props.styles.label
      }, jsx(Heading, {
        level: "h4",
        as: "h2"
      }, t('Title'))), jsx("div", null, content)), jsx("div", null, !this.props.isEditing && !this.isContentLocked() && jsx("div", {
        css: this.props.styles.editButtonWrapper
      }, jsx(EditButton, {
        ref: this.handleEditButtonRef,
        screenreaderText: t('Edit Title'),
        scrollKey: this.props.scrollKey,
        onClick: this.toggleEditing,
        "data-automation": "sdk-build-edit-title"
      }))));
    }
  }]);
}(Component), _defineProperty(_QuizTitlePresenter, "displayName", 'QuizTitle'), _defineProperty(_QuizTitlePresenter, "componentId", "Quizzes".concat(_QuizTitlePresenter.displayName)), _defineProperty(_QuizTitlePresenter, "propTypes", {
  changeQuizTitle: PropTypes.func.isRequired,
  errorsShowing: ImmutablePropTypes.map.isRequired,
  hideError: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  // injected by makeEditable
  lockBlueprintContentEnabled: PropTypes.bool.isRequired,
  onQuizUpdated: PropTypes.func.isRequired,
  quiz: ImmutablePropTypes.record.isRequired,
  saveQuizChange: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  scrollKey: PropTypes.string,
  showError: PropTypes.func.isRequired,
  switchOffEditing: PropTypes.func.isRequired,
  // injected by makeEditable
  switchOnEditing: PropTypes.func.isRequired,
  // injected by makeEditable
  workingQuiz: ImmutablePropTypes.record.isRequired,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_QuizTitlePresenter, "defaultProps", {
  scrollKey: void 0
}), _QuizTitlePresenter)) || _class);
export default QuizTitlePresenter;